/* ==========================================================================
   评论乱码兜底（2026-08-26）
   --------------------------------------------------------------------------
   现象：评论正文里成对出现替换符方块，如 I<�><�>ve / didn<�><�>t / Comfortable<�><�>Soft。

   根因：**不是主题代码的问题**。Judge.me 接口返回的 JSON 原始字节里就是两个
         连续的 U+FFFD（EF BF BD EF BF BD），说明这批评论在导入 Judge.me 之前
         就已经被错误编码解码过一次 —— 原文的 U+2019（’）和 U+2014（—）这类
         「通用标点区」三字节字符被替换成了替换符，坏数据直接存进了它的库。
         实证：curl 接口拿到 b'hat I didn\xef\xbf\xbd\xef\xbf\xbdt have t'。

   为什么要有这个文件：
     `amada-reviews.js` 里的 fixMojibake 只管我们自建评论区（渲染前就修好，无闪烁）。
     但商品模板还挂着 **Judge.me 官方 App block**（revamp 版，
     `.jdgm-review-content__body-content`），那套 DOM 从头到尾是 Judge.me 自己
     生成的，我们的渲染代码够不着 —— 表现就是「自建评论区已修好，官方 widget
     还在乱码」。这里补一层 DOM 兜底，把两边和 JSON-LD 一起兜住。

   ⚠️ 治本仍是让运营在 Judge.me 后台修正/重新导入这些评论。本文件只是止血：
      我们改不了别人的数据库，而以后每批导入的坏数据还会继续出现。

   ⚠️ 还原规则与 `amada-reviews.js` 的 fixMojibake **同源**，改一处必须同步另一处。
   ========================================================================== */
(function () {
  'use strict';

  /* 兜底范围：Judge.me 的全部 DOM（含隐藏数据容器 .jdgm-review-widget-data 与
     给 Google 抓的结构化数据 .jdgm-server-jld —— 后者不修的话乱码会进搜索结果的
     富摘要）+ 我们自建的评论区（防止将来有绕过 fixMojibake 的渲染路径）。
     故意不全站扫：限定容器才不会误伤别处内容。 */
  var ROOTS = '[class*="jdgm"], .amada-reviews, [data-amada-reviews]';

  var MOJIBAKE = /�+/g;
  function fixMojibake(str) {
    return str.replace(MOJIBAKE, function (m, offset, whole) {
      var rest = whole.slice(offset + m.length);
      /* 缩写形式：'s 't 've 'll 're 'd 'm，且后面必须是词边界，
         否则 "comfortable��soft" 会因为 soft 以 s 开头被误判成撇号 */
      if (/^(s|t|ve|ll|re|d|m)\b/i.test(rest)) return '’';
      /* 破折号：稿源里有 "comfortable��soft"（两侧紧贴）也有
         "position�� beyond"（后面带空格）。后者若直接替换会得到
         "position— beyond" 这种一边贴一边空的排版，补一个前导空格补齐。 */
      var prev = offset > 0 ? whole.charAt(offset - 1) : ' ';
      return prev !== ' ' && rest.charAt(0) === ' ' ? ' —' : '—';
    });
  }

  /* 只改文本节点，不碰元素结构 —— 避免动到 Judge.me 自己挂的事件与 data-*。
     script 节点（JSON-LD）的子节点同样是文本节点，会被 TreeWalker 一并覆盖。 */
  function sweep() {
    var roots = document.querySelectorAll(ROOTS);
    var changed = 0;
    for (var i = 0; i < roots.length; i++) {
      var walker = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf('�') < 0) continue;
        node.nodeValue = fixMojibake(node.nodeValue);
        changed++;
      }
    }
    return changed;
  }

  /* Judge.me 是异步渲染的（翻页、展开 More、筛选都会重绘），必须持续监听。
     🚨 自己的改写会触发 characterData 回调 —— 扫描期间先 disconnect 再接回，
        否则是死循环。debounce 是为了把 widget 一次渲染里的成百次 mutation
        合并成一次扫描。 */
  var observer = null;
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (observer) observer.disconnect();
      sweep();
      if (observer) observer.observe(document.body, OBSERVE_OPTS);
    }, 200);
  }

  var OBSERVE_OPTS = { childList: true, subtree: true, characterData: true };

  function start() {
    sweep(); // 服务端直出的那部分（JSON-LD、数据容器）立刻修掉
    observer = new MutationObserver(schedule);
    observer.observe(document.body, OBSERVE_OPTS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
